export const columnsLabels = [
  { key: 'procurementStage', label: 'Stage' },
  { key: 'internalId', label: 'internal ID' },
  { key: 'skuId', label: 'SKU ID' },
  { key: 'vehicleOwnership', label: 'Vehicle Ownership' },
  { key: 'tenant', label: 'Holding company' },
  { key: 'description', label: 'Description' },
  { key: 'color', label: 'Colour' },
  { key: 'condition', label: 'Condition' },
  { key: 'kilometersAtPurchase', label: 'Kilometers At Purchase' },
  { key: 'vin', label: 'VIN' },
  { key: 'plate', label: 'Plate' },
  { key: 'location', label: 'Location' },
  { key: 'supplierOrderId', label: 'Order ID' },
  { key: 'orderDate', label: 'Order Date' },
  { key: 'dealer', label: 'Dealer' },
  { key: 'cancelledDate', label: 'Cancelletion Date' },
  { key: 'retailPrice', label: 'Retail Price' },
  { key: 'retailPriceBeforeTax', label: 'Retail Price Before Tax' },
  { key: 'vat', label: 'VAT' },
  { key: 'extras', label: 'Extras' },
  { key: 'extrasPrice', label: 'Extras Price' },
  { key: 'specialClassificationFee', label: 'ETT (Ειδικό τέλος ταξινόμησης)' },
  { key: 'discountPercentage', label: 'Discount Percentage (%)' },
  { key: 'discountWithoutVat', label: 'Discount' },
  { key: 'agreedPurchasePrice', label: 'Agreed P.P.' },
  { key: 'finalPurchasePrice', label: 'Final P.P.' },
  { key: 'agreedCustomsDate', label: 'Agreed Customs Date' },
  { key: 'estimatedCustomsDate', label: 'Estimated Customs Date' },
  { key: 'customsEntryDate', label: 'Customs Entry Date' },
  { key: 'plannedDownpaymentDate', label: 'Planned Downpayment Date' },
  { key: 'licenseIssuanceDate', label: 'License Issuance Date' },
  { key: 'insuranceProvider', label: 'Insurance Provider' },
  { key: 'insuranceDate', label: 'Insurance Date' },
  { key: 'insuranceRenewalDate', label: 'Insurance Renewal Date' },
  { key: 'plannedReceiptDate', label: 'Planned Receipt Date' },
  { key: 'receiptDate', label: 'Receipt Date' },
  { key: 'sourcingType', label: 'Sourcing Type' },
  { key: 'financingType', label: 'Financing Type' },
  { key: 'financingProvider', label: 'Financing Provider' },
  { key: 'vehiclePurchaseDate', label: 'Vehicle Purchase Date' },
  { key: 'leaseStartDate', label: 'Lease Start Date' },
  { key: 'leaseMonthlyInstallment', label: 'Lease Monthly installment' },
  { key: 'defleetedDate', label: 'Defleeted Date' },
  { key: 'invoiceNumber', label: 'Invoice Number' },
  { key: 'netPrice', label: 'Net Price' },
  { key: 'registrationTax', label: 'Registration Tax' },
  { key: 'invoiceDetailsVat', label: 'Invoice Vat' },
  { key: 'transferFee', label: 'Transfer Fee' },
  { key: 'plateReleaseFee', label: 'Plate Release Fee' },
  { key: 'reservationType', label: 'Reservation Type' },
];

export const FLEET_VEHICLES_TABS = {
  all: {
    label: 'All',
    key: '',
  },
  created: {
    label: 'Created',
    key: 'created',
  },
  order: {
    label: 'Order',
    key: 'order',
  },
  payment: {
    label: 'Payment',
    key: 'payment',
  },
  dealer: {
    label: 'Dealer',
    key: 'dealer',
  },
  procurement: {
    label: 'Procurement',
    key: 'procurement',
  },
  fleet: {
    label: 'Fleet',
    key: 'fleet',
  },
  cancelled: {
    label: 'Cancelled',
    key: 'cancelled',
  },
  defleeted: {
    label: 'Defleeted',
    key: 'defleeted',
  },
};
